const subnav = () => {
	let categoriesDiv = document.querySelectorAll('.categories-div');
	if (categoriesDiv) {
		function openMiniNav(event) {
			let dataId = event.target.dataset.id;
			let categoriesListMobile = document.querySelectorAll(
				'.categories-list--mobile'
			);
			let width = window.innerWidth;
			if (categoriesListMobile && width < 600) {
				// check to see if any subnavs are open
				categoriesListMobile.forEach((item) => {
					let hasMobileOpenClass = item.classList.contains(
						'categories-list--mobileOpen'
					);
					// check to see the dataid
					let itemDataId = item.dataset.id;
					// if the open subnav is not the item trying to be opened, remove the class to close it
					if (hasMobileOpenClass && itemDataId !== dataId) {
						item.classList.remove('categories-list--mobileOpen');
						item.setAttribute('aria-expanded', false);
					}
				});
			}

			// find the subnav trying to be toggled
			let categoriesList = document.querySelector(
				'.categories-list--mobile[data-id="' + dataId + '"]'
			);
			// if the subnav exists toggle the class to open or close it
			if (categoriesList) {
				categoriesList.classList.toggle('categories-list--mobileOpen');
			}
		}
		function addAriaLabels() {
			let list = event.target.querySelector('.categories-list');
			list.setAttribute('aria-expanded', true);
		}
		function removeAriaLabels() {
			let lists = document.querySelectorAll('.categories-list');
			lists.forEach((item) => {
				item.setAttribute('aria-expanded', false);
			});
		}
		// Listen for the focusin event on the entire document
		document.addEventListener('focusin', function (event) {
			const focusedElement = event.target;

			// Check if the focused element does not have the class 'crumb'
			const isCrumb = focusedElement.classList.contains('crumb');

			// Check if the focused element is outside the 'services-black-block'
			const isOutsideServicesBlock = !focusedElement.closest(
				'.services-black-block'
			);

			if (isCrumb || isOutsideServicesBlock) {
				removeAriaLabels();
				// Code to execute when focus is not on a 'crumb' element or is outside 'services-black-block'
				let categoriesListAll = document.querySelectorAll('.categories-list');
				categoriesListAll.forEach((item) => {
					item.classList.remove('categories-list--active');
				});
			}
		});
		categoriesDiv.forEach((el) => {
			el.addEventListener('click', openMiniNav);
			el.addEventListener('mouseenter', addAriaLabels);
			el.addEventListener('mouseleave', removeAriaLabels);

			el.addEventListener('focus', function () {
				let categoriesListAll = document.querySelectorAll('.categories-list');
				categoriesListAll.forEach((item) => {
					if (item.classList.contains('categories-list--active')) {
						item.classList.remove('categories-list--active');
					}
				});
				let categoriesList = el.querySelector('.categories-list');
				categoriesList.classList.add('categories-list--active');
				categoriesList.setAttribute('aria-expanded', true);
			});
		});
		document.addEventListener('keydown', function (e) {
			if (
				(e.key === 'Escape' && e.target.classList.contains('contract-a')) ||
				(e.key === 'Escape' && e.target.classList.contains('categories-div'))
			) {
				$('.categories-list').removeClass('categories-list--active');
				$('.categories-list').attr('aria-expanded', false);
			}
		});
	}
};

export default subnav;
